import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as firebase from 'firebase';
import { UserService } from '../../service/user.service';
import { NgForm } from '@angular/forms';
import { Location } from '@angular/common';
import { StorageService } from '../../service/storage.service';

@Component({
  selector: 'app-pacijent',
  templateUrl: './pacijent.component.html',
  styleUrls: ['./pacijent.component.css']
})
export class PacijentComponent implements OnInit, OnDestroy {
  today: any = new Date().toISOString().slice(0, 10);
  fullYear: number = new Date().getFullYear();
  pacijentid = this.route.snapshot.params['id'];
  pacijent: any = {};
  kontakt;
  kontakti: any = [];
  istorija: any = [];
  allRef;
  kontaktRef;
  statistika: any = [];
  user;
  pregledi: any = [];
  protokol: any;
  protokolRef: any;
  dijagnozaData: any = [];
  dgRef: any;
  href;
  imageRef: any;
  imageList: any = [];
  naplata: any = [];
  naplataRef;
  status = 'otvoreno';
  statusCheck = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private location: Location,
    private storageService: StorageService
  ) {
    this.href = this.router.url;
    this.allRef = firebase
      .database()
      .ref()
      .child('pacijenti/' + this.pacijentid);

    this.kontaktRef = firebase
      .database()
      .ref('istorija/' + this.pacijentid)
      .orderByChild('date');
    this.protokolRef = firebase.database().ref('protokol');

    this.user = this.userService.getProfile();
    // this.dgRef = firebase
    //   .database()
    //   .ref('/istorija/' + this.pacijentid);
    this.imageRef = firebase.database().ref('/images/' + this.pacijentid);
    this.naplataRef = firebase.database().ref('/naplata/');
  }

  onDeleteClick() {
    if (confirm('Da li ste sigurni da zelite da obriste Pacijenta?')) {
      this.allRef = firebase
        .database()
        .ref()
        .child('pacijenti/' + this.pacijentid)
        .remove()
        .then(() => {
          this.router.navigate(['/']);
        });
    }
  }

  dodajKontakt(form: NgForm) {
    const protokol = (this.protokol.brojProtokola += 1);
    let pregled = form.value.pregled;
    let date = new Date(form.value.date).valueOf();

    this.protokolRef = firebase
      .database()
      .ref('protokol')
      .update({
        brojProtokola: protokol
      });
    if (date > Date.now().valueOf()) {
      alert('Ne mozete uneti datum veci od danasnjeg za datum pregleda!');
      return;
    }
    if (date === null || date === undefined || date === 0) {
      date = Date.now().valueOf();
    }

    this.kontaktRef = firebase
      .database()
      .ref('istorija/' + this.pacijentid)
      .push(
        (this.kontakt = {
          uid: this.pacijentid,
          doktor: this.user.name,
          spec: this.user.spec,
          pregled: pregled,
          date: date,
          pacijent: this.pacijent,
          protokol: protokol,
          naplata: '0',
          titula: this.user.titula,
          status: this.status,
          th: '',
          nalaz: ''
        })
      );
    this.statistika = firebase
      .database()
      .ref('/statistika')
      .child(this.user.uid)
      .push({
        pregled: pregled,
        date: this.today
      });

    this.kontakti.sort((a, b) => b.data.date - a.data.date);
    pregled = form.resetForm();
  }
  onFileSelection(event) {
    const fileList: FileList = event.target.files;
    if (fileList.length > 0) {
      const file: File = fileList[0];
      this.storageService.uploadFile(file).then(data => {
        this.storageService.handleImageUpload(data, this.pacijentid);
      });
    }
  }
  ngOnInit() {
    // window.scrollTo(0, 9999);

    this.allRef.once('value').then(snapshot => {
      this.pacijent = snapshot.val();
    });
    this.protokolRef.once('value').then(snapshot => {
      this.protokol = snapshot.val();
    });

    this.kontaktRef.on('child_added', data => {
      this.kontakti.push({
        key: data.key,
        data: data.val()
      });
      this.kontakti.sort(
        (a, b) =>
          new Date(b.data.date).valueOf() - new Date(a.data.date).valueOf()
      );
      this.kontakti.forEach(i => {
        if (i.data.status === 'otvoreno') {
          this.statusCheck = false;
        }
      });
    });
    this.kontaktRef.on('child_added', async data => {
      await firebase
        .database()
        .ref('istorija/' + this.pacijentid + '/' + data.key + '/dijagnoza/')
        .on('child_added', snap => {
          this.dijagnozaData.push({
            key: snap.key,
            data: snap.val()
          });
        });
    });

    this.imageRef.on('child_added', data => {
      this.imageList.push({
        key: data.key,
        data: data.val()
      });
    });
    this.naplataRef.on('child_added', data => {
      this.naplata.push({
        key: data.key,
        data: data.val()
      });
    });
  }
  obrisiSliku(key, name) {
    this.storageService
      .deleteImage(this.pacijentid, key)
      .then(() => this.router.navigate(['/brisanje']))
      .then(() => this.location.back());
    firebase
      .storage()
      .ref('/image/')
      .child(name)
      .delete();
  }

  ngOnDestroy() {
    this.kontaktRef.off();
  }
}
